export default {
    getMessageFromError( error, fallbackMessage = 'An unexpected error occurred' ) {
        return error.response?.data?.message || error?.message || error || fallbackMessage;
    },
};
